import React from 'react';
import logo from '../assets/logo.png';

const Footer = () => {
    return (
        <footer>
            <img src={logo} alt=""/>
            <span>Built by <b>Susan Hirego, 2023</b></span>
        </footer>
    )
}

export default Footer